import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Link } from "react-router-dom";

import { faSignInAlt, faHome, faHandshake, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//import FeedBackModal from "./FeedBackModal";
import TimeLine from "./TimeLine";
import ProductLine from "./ProductLine";
import Headline from "../../Headline/Headline";
import CardBubble from "../../UI/Card/CardBubble";
import * as GlobalConstant from "../../Constants/GlobalConstant";

import { useIntl } from "react-intl";

const Landing = (props) => {
    const intl = useIntl();

    const [modal, setModal] = useState(null);
    const user = useSelector(state => state.contacts.user);

    const title = intl.messages.homeTitle;
    const subtitle = intl.messages.homeMessage;

    let isAuthenticated = user != null;
    const linkSignIn = isAuthenticated ? GlobalConstant.DASHBOARD_PATH : GlobalConstant.LOGIN_PATH;
    const linkGeneral = "/doc/hub/getting-started";
    const linkSubscribe = "https://web.openrainbow.com/#/subscribe";
    const linkPartner = "https://www.al-enterprise.com/en/partners/dspp";

    // function onOpenFeedBackForm() {
    //     setModal(
    //         <FeedBackModal />
    //     )
    // };

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            {/* Instance of the popup to fill the feedback form */}
            {modal}

            <div className="row">
                {/* Message d'accueil */}
                <div className="col">
                    <div className="card">
                        <div className="card-text">
                            {intl.messages.homeWelcomeMessage}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12 col-md-6 col-xl-4">
                    <div className="row">
                        <div className="d-flex col">
                            {isAuthenticated && <CardBubble
                                title={intl.messages.menuDashboard}
                                description={intl.messages.landingMsgBox3}
                                action={intl.messages.discover}
                                icon={faHome}
                                colorIcon="blue"
                                link={linkSignIn}
                                align="center"
                                extLink={false}
                            >
                            </CardBubble>}

                            {!isAuthenticated && <CardBubble
                                title={intl.messages.landingMsgBox1}
                                action={intl.messages.timelineLogin}
                                icon={faSignInAlt}
                                colorIcon="blue"
                                link={linkSignIn}
                                align="center"
                                extLink={false}
                            >
                            </CardBubble>}

                        </div>
                        {/* uncomment this, with feedback*/}
                        {/* <div className="col">
                            <div className="card bg-fog">
                                <div className="card-body text-center">
                                    <h3 className="text-muted mt-3">{intl.messages.landingVideoTitle}</h3>
                                    <p className="text-muted mt-3">{intl.messages.landingVideoMsg}</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="d-flex col">

                            {/* get started ici */}
                            {isAuthenticated && <div className="card bg-fog">
                                <div className="card-body text-center mt-3">
                                    <h4 className="card-title mb-2">{intl.messages.landingMsgBox5}</h4>
                                </div>
                                <div className="card-footer">
                                    <Link to={linkGeneral} className="btn btn-link">
                                        <FontAwesomeIcon icon={faArrowRight} className="mr-2 text-orange" />
                                        {intl.messages.startNow}
                                    </Link>
                                </div>
                            </div>
                            }

                            {/* create account */}
                            {!isAuthenticated && <div className="card bg-fog">
                                <div className="card-body text-center mt-3">
                                    <h4 className="card-title mb-2">{intl.messages.landingMsgBox2}</h4>
                                </div>
                                <div className="card-footer">
                                    <a className="btn btn-link" target="_blank" href={linkSubscribe} rel="noopener noreferrer" >
                                        <FontAwesomeIcon icon={faArrowRight} className="mr-2 text-orange" />{intl.messages.register}
                                    </a>
                                </div>
                            </div>
                            }
                        </div>

                        {/* FeedBack */}
                        {/* <div className="col">
                            <div className="card">
                                <div className="card-body text-center">
                                    <h4 className="card-title mb-2">{intl.formatMessage({ id: "landingTitleFeedback" }, { b: chunks => <b>{chunks}</b> })}</h4>
                                    <p className="card-text">{intl.messages.landingMsgFeedback}</p>
                                </div>
                                <div className="card-footer">
                                    <button className="btn btn-link"
                                        data-target="#FeedBackFormId"
                                        data-toggle="modal"
                                        onClick={onOpenFeedBackForm} >
                                        <FontAwesomeIcon icon={faArrowRight} className="mr-2 icon-orange" />{intl.messages.landingBtnFeedback}
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* delete this, with feedback*/}
                <div className="d-flex col-xs-12 col-md-6 col-xl-4">
                    <div className="card">
                        <div className="card-body text-center">
                            <h3 className="mt-3">{intl.messages.landingVideoTitle}</h3>
                            <p className="mt-3">{intl.messages.landingVideoMsg}</p>
                        </div>
                        <div className="footer">
                        <img alt="guirlande" src="./images/Guirland.png" className="card-img-bottom"/>
                            
                        </div>
                    </div>
                </div>
                {/* delete this, with feedback*/}

                {/* Partner */}
                <div className="d-flex col-xs-12 col-md-12 col-xl-4">
                    <CardBubble
                        title={intl.messages.landingMsgBox4}
                        description={intl.messages.landingMsgPartner}
                        action={intl.messages.learnMore}
                        icon={faHandshake}
                        colorIcon="green"
                        link={linkPartner}
                        align="center"
                        extLink={true}
                    >
                    </CardBubble>
                </div>
            </div>

            {/* Product... SDK */}
            <ProductLine />

            {/* Rainbow ApiHub Journey */}
            <TimeLine isAuthenticated={isAuthenticated} />

        </div>
    );
}

Landing.propTypes = {
};

export default Landing;